import { styled } from "styled-components";
export const HistoryContainer = styled.div``;
export const HistoryWrapper = styled.div`
  padding: 120px 0;
  @media all and (max-width: 900px) {
    padding: 100px 0;
  }
  @media all and (max-width: 768px) {
    padding: 9.115vw 0;
  }
`;
export const HistoryWrap = styled.div`
  .history-wrap {
    width: 100%;
    display: flex;
    gap: 64px;
    > div {
      padding: 16px 0;
    }
    h6 {
      min-width: 160px;
      text-align: right;
      color: #233e99;
      font-weight: bold;
      font-size: 32px;
      line-height: 1.3;
    }
    > ul {
      padding-bottom: 64px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      li {
        display: flex;
        gap: 32px;
        span {
          font-weight: bold;
          color: #6f6f6f;
          font-size: 20px;
          line-height: 1.4;
          display: block;
          min-width: 90px;
        }
        p {
          color: #242424;
          font-size: 20px;
          line-height: 1.4;
          text-align: left;
        }
      }
    }
  }
  @media all and (max-width: 900px) {
    .history-wrap {
      gap: 40px;
    }
  }
  @media all and (max-width: 768px) {
    > ul {
      > li {
        display: flex;
        flex-direction: column;
        gap: 5.208vw;
      }
    }
    .history-wrap {
      gap: 3.125vw;
      flex-wrap: wrap;
      h6 {
        width: 100%;
        text-align: left;
        font-size: 5.208vw;
      }
      > div {
        padding: 0;
      }
      > ul {
        flex: 1;
        padding-bottom: 0;
        li {
          gap: 1.302vw;
          display: flex;
          flex-direction: column;
          text-align: left;

          span {
            font-size: 3.646vw;
          }
          p {
            font-size: 3.646vw;
          }
        }
      }
    }
  }
`;

export const HistoryCircle = styled.div<{ listsLength: number }>`
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 20px;
  border: 4px solid #233e99;
  position: relative;
  &::after {
    content: "";
    width: 2px;
    height: ${(props) =>
      props.listsLength ? `${props.listsLength * 32}px` : "0px"};
    background-color: #a5a5a5;
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
  }
  @media all and (max-width: 768px) {
    width: 3.125vw;
    height: 3.125vw;
    border-radius: 3.125vw;
    border-width: 0.651vw;
    &::after {
      width: 0.391vw;
      height: ${(props) =>
        props.listsLength ? `${props.listsLength * 6.51}vw` : "0px"};

      top: calc(100% + 1.823vw);
    }
  }
`;
